var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 755.89 778.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ecf2fa;}.cls-2{fill:#2eca8b;}.cls-3,.cls-4{fill:#274b5b;}.cls-10,.cls-11,.cls-16,.cls-4{opacity:0.2;}.cls-10,.cls-11,.cls-17,.cls-19,.cls-20,.cls-4,.cls-5,.cls-6,.cls-9{isolation:isolate;}.cls-12,.cls-19,.cls-20,.cls-5{fill:#fff;}.cls-5{opacity:0.3;}.cls-13,.cls-6{opacity:0.4;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:#5b40f1;}.cls-8{fill:#f17425;}.cls-9{fill:#9084e2;}.cls-19,.cls-9{opacity:0.8;}.cls-10{fill:#70320c;}.cls-11{fill:#f17425;}.cls-14{fill:#426270;}.cls-15{opacity:0.9;}.cls-17{fill:#5c7869;opacity:0.6;}.cls-18{fill:#94e0f7;}.cls-20{opacity:0.15;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 574.82,
    x2: 755.89,
    y2: 574.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 849.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3f6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c6ebfd"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.21,520.18h127.5a26.44,26.44,0,0,1-26.44,26.44H315.65a26.44,26.44,0,0,1-26.44-26.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M417.25,522.4a26.44,26.44,0,0,1-13.94,21.68,25.53,25.53,0,0,1-4.91,1.76l.09-.24a10.9,10.9,0,0,0-10-14.51l-96.22-2.75a26,26,0,0,1-1.18-6,15,15,0,0,0,2.13.15h33.62v2.35h7.05v-2.35h18c-.19.41-.4.82-.59,1.23L378,523.7v-1.18h37.32A14.49,14.49,0,0,0,417.25,522.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 306.25,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 308.01,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 322.7,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 352.08,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 366.77,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 381.46,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 376.76,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 362.66,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 347.97,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 333.28,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 318.59,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 303.9,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 337.39,
    y: 523.71,
    width: 2.35,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 320.84,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 335.44,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 350.03,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 379.21,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 393.8,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 364.61,
    y: 523.71,
    width: 2.35,
    height: 21.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M745.61,324.52H601.72q-.28-4.11-.68-8.23h56.41a10.28,10.28,0,0,0,0-20.56H598c-2.91-14.14-7.53-27.38-14.63-38.57-13.91-21.92-35.62-32.82-57-35.1s-42.8,3.15-63.84,9c-28,7.83-60.95,14.88-82.06-11-12.49-15.34-17.47-40.47-13-62.37a159.19,159.19,0,0,1,4.38-15.89H446a10.28,10.28,0,0,0,0-20.56H377.27a58,58,0,0,0,.76-9.58,52.81,52.81,0,0,0-19.66-40.17C347.58,63,334.95,60,322.53,57.86,294.79,53,266.18,51.53,239.16,61c-25.57-27.59-61.58-36.92-93-23.87a60.89,60.89,0,0,0-23.31,16.52h61.3a10,10,0,0,1,0,20h-72c-4.62,15-4.58,32.52-4.35,49.07,0,1.86.05,3.72.08,5.58H136.9a10.28,10.28,0,1,1,0,20.56H108.25l.16,11.16h67.27a10.28,10.28,0,0,1,0,20.56h-67c0,2.35.06,4.74.1,7.12.24,16.7.42,33.86-3.92,49.5C91.47,285.37,44,297,18.34,335.1h108a10.28,10.28,0,1,1,0,20.56H7.87q-1.4,3.74-2.55,7.64H81.67a10.28,10.28,0,1,1,0,20.56H1a138.46,138.46,0,0,0,7.76,65.62c17.44,45.45,58,68.49,96.08,67.77s74.42-21.15,108.59-43.82c25.82-17.15,52.85-36.3,81.59-33.59,29.31,2.76,54.4,27.66,80.92,44.62,43.19,27.62,93.5,34.67,140,19.63,20.56-6.65,40.94-18,56-37.92,14.61-19.39,22.91-45,27-72.27h39.37a10,10,0,1,0,0-20H601.3c.74-9.2,1.08-18.46,1.1-27.62v-1.18H745.61a10.28,10.28,0,0,0,0-20.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266.9,494.91s-48,59.78-54.51,143.61a3.68,3.68,0,0,1-7.17.87c-16.45-50.07-51.38-194.83,57.58-283.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M211.68,643.5a3.64,3.64,0,0,0,1.43,1.93,3.67,3.67,0,0,1-5.54-1.93c-16.45-50.07-51.38-194.83,57.58-283.14l.1,3.33C161.17,452.27,195.44,594.06,211.68,643.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M200.94,624.14c-.28-23.24,5.65-47.59,13.42-69.4,4-11.16,8.44-21.65,12.81-31a198.7,198.7,0,0,0,18.58-93.49c-.86-18.64-1.56-39.55-1.56-58.17,8.61-10.66,5.68-11.62,17.44-21.15l4.11,138.66s-48,59.78-54.51,143.61a3.56,3.56,0,0,1-1.4,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.78,545.44a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,200.78,545.44Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,200.78,542.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.78,547.21a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,200.78,547.21Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,200.78,541.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209,469.65a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,209,469.65Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,209,466.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209,471.41a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,209,471.41Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,209,466.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M497.5,469.65a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,497.5,469.65Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,497.5,466.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M497.5,471.41a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,497.5,471.41Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,497.5,466.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M495.74,469.65a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,495.74,469.65Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,495.74,466.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M495.74,471.41a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,495.74,471.41Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,495.74,466.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 218.71,
    y: 409.72,
    width: 2.35,
    height: 192.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.06,
    y: 405.02,
    width: 2.35,
    height: 197.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.36,
    y: 409.72,
    width: 2.35,
    height: 192.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 232.22,
    y: 384.45,
    width: 2.35,
    height: 173.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.57,
    y: 384.45,
    width: 2.35,
    height: 173.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.87,
    y: 384.45,
    width: 2.35,
    height: 173.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M474.25,703.51a47.63,47.63,0,0,1-47.55-47.63V609.49h12.93v46.38a34.7,34.7,0,1,0,57.17-26.44l8.37-9.85a47.63,47.63,0,0,1-27,83.76Q476.21,703.51,474.25,703.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M468.86,683.38a28.77,28.77,0,0,1-4.18-.31l1.88-12.79a15.41,15.41,0,1,0-7-27.6l-7.72-10.37a28.33,28.33,0,1,1,17,51.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 473.12,
    cy: 593.04,
    r: 9.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M491.61,645.27a3.64,3.64,0,0,1-1.43,1.93,3.67,3.67,0,0,0,5.54-1.93c16.45-50.07,51.38-194.83-57.58-283.14l-.1,3.33C542.12,454,507.86,595.82,491.61,645.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436.88,500.79s48,59.78,54.51,143.61a3.68,3.68,0,0,0,7.17.87C515,595.2,549.94,450.44,441,362.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M502.85,630c.28-23.24-5.65-47.59-13.42-69.4-4-11.16-8.44-21.65-12.81-31A198.7,198.7,0,0,1,458,436.16c.86-18.64,1.56-39.55,1.56-58.17-8.61-10.66-5.68-11.62-17.44-21.15L438,495.5s48,59.78,54.51,143.61a3.56,3.56,0,0,0,1.4,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.79,546a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,502.79,546Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,502.79,543.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M502.79,547.8a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,502.79,547.8Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,502.79,542.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 482.52,
    y: 409.13,
    width: 2.35,
    height: 198.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 480.17,
    y: 408.54,
    width: 2.35,
    height: 182.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 484.87,
    y: 415.01,
    width: 2.35,
    height: 192.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 469.01,
    y: 389.74,
    width: 2.35,
    height: 173.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 466.66,
    y: 389.74,
    width: 2.35,
    height: 168.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 471.36,
    y: 389.74,
    width: 2.35,
    height: 173.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M495.1,648.1a8.39,8.39,0,0,1-1-.06,8,8,0,0,1-7.1-7.41c-6.3-81.53-53.08-140.6-53.55-141.19l6.87-5.52c.5.62,12.45,15.6,25.32,41.14,11.55,22.91,25.93,58.83,29.84,101.29,8-25.12,19.6-71.56,16.92-122.19C509,450,484,398.58,438.21,361.44l5.55-6.85a202.23,202.23,0,0,1,58.54,76.1c10.95,24.86,17.31,52.78,18.91,83,2.88,54.46-10.32,104.1-18.45,128.84A8,8,0,0,1,495.1,648.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M93.55,778.12H51.84a6.46,6.46,0,1,1,0-12.93H93.55a6.46,6.46,0,1,1,0,12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M277.5,720.51a54,54,0,0,1-35.05-95.22l8.37,9.85a41.13,41.13,0,1,0,67.77,31.34V564.83h12.93V666.48a54,54,0,0,1-54,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M376.44,745.24A30.26,30.26,0,0,1,346.23,715V614.8h12.93V715a17.33,17.33,0,1,0,28.56-13.21l8.37-9.85a30.26,30.26,0,0,1-17.15,53.22Q377.68,745.24,376.44,745.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 345.03,
    y: 565.42,
    width: 12.93,
    height: 31.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M280.84,694.55a28.68,28.68,0,0,1-4.18-.31l1.88-12.79a15.41,15.41,0,1,0-7-27.6l-7.72-10.37a28.33,28.33,0,1,1,17,51.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389.69,677.06a20.56,20.56,0,1,1,20.56-20.56A20.59,20.59,0,0,1,389.69,677.06Zm0-28.2a7.64,7.64,0,1,0,7.64,7.64A7.65,7.65,0,0,0,389.69,648.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M288,624.77A20.56,20.56,0,1,1,308.6,604.2,20.59,20.59,0,0,1,288,624.77Zm0-28.2a7.64,7.64,0,1,0,7.64,7.64A7.65,7.65,0,0,0,288,596.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M567.13,624.77a20.56,20.56,0,1,1,20.56-20.56A20.59,20.59,0,0,1,567.13,624.77Zm0-28.2a7.64,7.64,0,1,0,7.64,7.64A7.65,7.65,0,0,0,567.13,596.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 164.65,
    cy: 647.09,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 426.7,
    cy: 727.59,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M584.76,749.92H571.83a34.71,34.71,0,0,0-34.67-34.67h-8.81V702.32h8.81A47.65,47.65,0,0,1,584.76,749.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M114.12,752.41H101.19a93.67,93.67,0,0,1,93.56-93.56h18.66v12.93H194.76A80.73,80.73,0,0,0,114.12,752.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M678,749.92H665.12A100,100,0,0,0,565.23,650H542.45V637.1h22.78A112.94,112.94,0,0,1,678,749.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M177.58,749.92H164.65a47.65,47.65,0,0,1,47.59-47.59h8.81v12.93h-8.81A34.71,34.71,0,0,0,177.58,749.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M607.08,778.12H115.29a6.46,6.46,0,1,1,0-12.93H607.08a6.46,6.46,0,0,1,0,12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.92,778.12a6.09,6.09,0,0,1-1.26-.13,6.78,6.78,0,0,1-1.21-.36,7.23,7.23,0,0,1-1.12-.59,6.85,6.85,0,0,1-1-.81,6.39,6.39,0,0,1-1.4-2.1,6.84,6.84,0,0,1-.36-1.21,6.24,6.24,0,0,1,0-2.53,6.84,6.84,0,0,1,.36-1.21,7.27,7.27,0,0,1,.59-1.12,6.47,6.47,0,0,1,1.79-1.79,7.23,7.23,0,0,1,1.12-.59,6.78,6.78,0,0,1,1.21-.36,6.31,6.31,0,0,1,2.53,0,6.79,6.79,0,0,1,1.21.36,7.24,7.24,0,0,1,1.12.59,6.47,6.47,0,0,1,1.79,1.79,7.24,7.24,0,0,1,.59,1.12,7.41,7.41,0,0,1,.37,1.21,6.53,6.53,0,0,1,0,2.53,7.41,7.41,0,0,1-.37,1.21,7.24,7.24,0,0,1-.59,1.12,6.41,6.41,0,0,1-.81,1,6.82,6.82,0,0,1-1,.81,7.24,7.24,0,0,1-1.12.59,6.79,6.79,0,0,1-1.21.36A6.09,6.09,0,0,1,28.92,778.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M672.88,778.12H631.17a6.46,6.46,0,1,1,0-12.93h41.71a6.46,6.46,0,0,1,0,12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M695.8,778.12a6.09,6.09,0,0,1-1.26-.13,6.78,6.78,0,0,1-1.21-.36,7.21,7.21,0,0,1-1.12-.59,6.8,6.8,0,0,1-1-.81,6.38,6.38,0,0,1-.81-1,7.24,7.24,0,0,1-.59-1.12,7.44,7.44,0,0,1-.37-1.21,6.53,6.53,0,0,1,0-2.53,7.44,7.44,0,0,1,.37-1.21,7.24,7.24,0,0,1,.59-1.12,6.47,6.47,0,0,1,1.79-1.79,7.21,7.21,0,0,1,1.12-.59,6.78,6.78,0,0,1,1.21-.36,6.31,6.31,0,0,1,2.53,0,6.78,6.78,0,0,1,1.21.36,7.22,7.22,0,0,1,1.12.59,6.47,6.47,0,0,1,1.79,1.79,7.29,7.29,0,0,1,.59,1.12,6.8,6.8,0,0,1,.36,1.21,6.24,6.24,0,0,1,0,2.53,6.8,6.8,0,0,1-.36,1.21,7.29,7.29,0,0,1-.59,1.12,6.44,6.44,0,0,1-.81,1,6.83,6.83,0,0,1-1,.81,7.22,7.22,0,0,1-1.12.59,6.78,6.78,0,0,1-1.21.36A6.09,6.09,0,0,1,695.8,778.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.1,647.51a8,8,0,0,1-7.64-5.57C192.32,617.2,179.12,567.57,182,513.1c1.6-30.22,8-58.14,18.91-83A202.23,202.23,0,0,1,259.45,354l5.55,6.85c-45.83,37.15-70.8,88.53-74.2,152.72-2.68,50.63,9,97.07,16.92,122.19,3.91-42.45,18.29-78.38,29.84-101.29,12.88-25.54,24.82-40.52,25.32-41.14l6.87,5.52h0c-.18.23-12,15.1-24.44,39.82-11.47,22.8-25.83,58.89-29.11,101.37a8,8,0,0,1-7.1,7.41A8.51,8.51,0,0,1,208.1,647.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M362.27,9.5a13.07,13.07,0,0,0-19.58,0C314.48,41.43,235,144.12,235,287.65c0,140.49,30.47,203.58,42.35,222.83,2.54,4.11,8.07,6.76,14.1,6.76H413.52c6.06,0,11.58-2.63,14.1-6.76C439.5,491.23,470,428.14,470,287.65,470,144.12,390.49,41.43,362.27,9.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 350.91,
    y: 128.28,
    width: 2.35,
    height: 387.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 348.56,
    y: 128.28,
    width: 2.35,
    height: 387.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 353.26,
    y: 128.28,
    width: 2.35,
    height: 387.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.23,124.75h-158a517.9,517.9,0,0,1,33.83-67.17q1.69-2.82,3.35-5.51C331.93,18.36,349.18,0,349.18,0s24,25.53,52.29,71.68l.41.68C411.17,87.72,420.84,105.24,430.23,124.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.05,123.05l-8.64-1.24c-14.27-20.87-53.74-63.46-108.14-69.33,1-1.88,5-5.72,6-7.51,7.81-12.84,14.92-21.47,20.73-29.69a17,17,0,0,1,27.56-.36A461.19,461.19,0,0,1,400,66.39c.12.22,1.42.45,1.55.68C410,82.43,425.53,91.91,429.05,123.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296,109.73a2.94,2.94,0,0,1-2.58-4.34c2.86-5.26,6-10.55,9.13-15.66,3-5,6.08-10.09,8.84-15.13a2.94,2.94,0,0,1,5.16,2.81c-2.81,5.16-5.94,10.34-9,15.35s-6.2,10.28-9,15.43A2.94,2.94,0,0,1,296,109.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M381.81,231.06c3.78-6.12,6.46-11.31,6.87-11.13s-1.76,5.7-5.6,11.91-7.79,10.63-8.1,10.38S378.06,237.2,381.81,231.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 387.95,
    cy: 236.2,
    rx: 8.69,
    ry: 0.75,
    transform: "translate(-13.1 449.4) rotate(-59.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M383.3,235.13c5.52,2.23,10.13,3.77,10,4.18s-5-.51-10.58-2.79-9.77-5-9.57-5.32S377.77,232.92,383.3,235.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M388.52,233.63c5,2.35,9.23,3.83,9.11,4.24s-4.62-.49-9.74-2.88-8.71-5.29-8.48-5.59S383.52,231.32,388.52,233.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M314.62,520.18H293.19c-6.06,0-11.58-2.64-14.1-6.77-11.87-19.3-42.34-82.54-42.34-223.37,0-137.91,73-238.21,104-274.48-27.77,32.9-87.9,120-87.9,257.25l35.25-49.46C287.37,225.27,216.18,432.35,314.62,520.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M300.24,517.53h-5.88c-6.06,0-11.58-2.64-14.1-6.77-11.87-19.3-42.34-82.54-42.34-223.37,0-137.91,73-238.21,103.94-274.46-15.77,18.69-42.08,55-61.8,108h0c-20.23,45.39-36.28,101.77-36.28,166.4,0,140.84,30.47,204.08,42.34,223.37C288.67,514.89,294.19,517.53,300.24,517.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M386.77,517.24H408.2c6.06,0,11.58-2.63,14.1-6.75,11.87-19.24,42.34-82.3,42.34-222.73,0-137.49-73-237.52-104-273.69,27.77,32.8,94.37,119.63,94.37,256.51L424.5,221.26C425.19,223.18,485.22,429.66,386.77,517.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M277.61,171.19a117.93,117.93,0,0,1,3.61-11.6,86.92,86.92,0,0,1,4-9.11c2.59-5,4.83-7.85,5.76-7.46s.48,3.91-.79,9.28c-.63,2.69-1.43,5.88-2.35,9.35L284.87,173,282,184.43c-.86,3.53-1.67,6.67-2.39,9.34-1.45,5.33-2.69,8.64-3.73,8.54s-1.65-3.63-1.52-9.3a86.85,86.85,0,0,1,.86-9.89A117.92,117.92,0,0,1,277.61,171.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 271.34,
    cy: 216.19,
    rx: 8.81,
    ry: 3.75,
    transform: "translate(10.39 444.82) rotate(-79.77)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M334.35,36.72c4.87-3.53,9.4-6.6,12.72-8.71s5.46-3.33,5.58-3.14-1.81,1.67-5,4l-12.44,9L322.8,47c-3.2,2.3-5.22,3.68-5.35,3.53s1.66-1.83,4.7-4.35S329.48,40.27,334.35,36.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M336.15,42.44c10.71-4.11,19.34-7.56,19.51-7.17.08.19-2,1.3-5.39,2.88s-8.23,3.63-13.58,5.69-10.31,3.75-13.91,4.84-5.88,1.65-5.94,1.46C316.69,49.74,325.45,46.55,336.15,42.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,195.55a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,195.55Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,192.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,197.31a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,197.31Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,155.3a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,155.3Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,152.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,157.07a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,157.07Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,151.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.36,168.23a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,362.36,168.23Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,362.36,165.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.36,170a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,362.36,170Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,362.36,164.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.36,314.53a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,362.36,314.53Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,362.36,311.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.36,316.3a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,362.36,316.3Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,362.36,311Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363,344.5a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,363,344.5Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,363,341.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M363,346.26a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,363,346.26Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,363,341Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340,306.31a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,340,306.31Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,340,303.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340,308.07a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,340,308.07Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,340,302.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340,336.27a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,340,336.27Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,340,333.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340,338a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,340,338Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,340,332.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,235.8a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,235.8Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,232.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,237.56a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,237.56Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,232.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.8,113a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,388.8,113Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,388.8,110.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.8,114.76a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,388.8,114.76Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,388.8,109.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.77,113a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,314.77,113Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,314.77,110.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.77,114.76a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,314.77,114.76Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,314.77,109.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.79,113a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,351.79,113Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,351.79,110.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.79,114.76a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,351.79,114.76Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,351.79,109.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,380.93a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,380.93Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,382.69a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,382.69Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,377.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,424a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,424Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,421.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,425.78a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,425.78Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,420.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,467.11a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,467.11Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,464.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,468.87a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,468.87Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,463.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.8,510.19a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,341.8,510.19Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,341.8,507.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.8,512a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,341.8,512Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,341.8,506.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 355.31,
    cy: 245.49,
    r: 49.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 355.9,
    cy: 227.28,
    r: 49.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.31,274a43.19,43.19,0,1,1,43.19-43.19A43.23,43.23,0,0,1,355.31,274Zm0-83.43a40.25,40.25,0,1,0,40.25,40.25A40.29,40.29,0,0,0,355.31,190.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M372.51,183l-28.33,95.15a49.4,49.4,0,0,1-19.58-10.41L350.45,181A49.82,49.82,0,0,1,372.51,183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M388.28,191.61l-26.21,88a48.54,48.54,0,0,1-5,.25,49.51,49.51,0,0,1-6-.36L379,185.67A49.66,49.66,0,0,1,388.28,191.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M320.35,241.28a1.18,1.18,0,0,1-1.16-1,47.59,47.59,0,0,1,5.79-31.2c3.08-5.28,6.7-8.45,10.77-9.4a1.18,1.18,0,1,1,.54,2.29c-3.41.8-6.53,3.6-9.27,8.3a45.24,45.24,0,0,0-5.5,29.65,1.17,1.17,0,0,1-1,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.39,234a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,389.39,234Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,389.39,231.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M389.39,235.8a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,389.39,235.8Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,389.39,230.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.31,286.62a55.82,55.82,0,1,1,55.82-55.82A55.88,55.88,0,0,1,355.31,286.62Zm0-99.3a43.48,43.48,0,1,0,43.48,43.48A43.53,43.53,0,0,0,355.31,187.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.81,514.89V429.15a114.93,114.93,0,0,1,30.59-78.22h0a115,115,0,0,1,30,77.62v86.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M358.55,362.4a111.92,111.92,0,0,0-27,72.94v84.26h-7.05V435.34a111.9,111.9,0,0,1,30.59-76.88h0Q356.86,360.4,358.55,362.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.52,433.68v84.74l-24.32.05c22.63-45.48,15.45-106.76,10.86-138A111.88,111.88,0,0,1,378.52,433.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M300.14,362.68c3.78-6.12,6.46-11.31,6.87-11.13s-1.76,5.7-5.6,11.91-7.79,10.63-8.1,10.38S296.39,368.81,300.14,362.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 305.49,
    cy: 366.18,
    rx: 8.69,
    ry: 0.75,
    transform: "translate(-164.99 444.04) rotate(-59.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.63,366.74c5.52,2.23,10.13,3.77,10,4.18s-5-.51-10.58-2.79-9.77-5-9.57-5.32S296.1,364.53,301.63,366.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M306.85,365.25c5,2.35,9.23,3.83,9.11,4.24s-4.62-.49-9.74-2.88-8.71-5.29-8.48-5.59S301.85,362.94,306.85,365.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.39,408.54a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,342.39,408.54Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,342.39,405.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.39,410.31a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,342.39,410.31Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,342.39,405Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.39,494.33a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,342.39,494.33Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,342.39,491.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.39,496.09a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,342.39,496.09Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,342.39,490.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.39,451.44a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,342.39,451.44Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,342.39,448.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.39,453.2a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,342.39,453.2Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,342.39,447.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.19,408.54a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,361.19,408.54Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,361.19,405.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.19,410.31a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,361.19,410.31Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,361.19,405Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.19,494.33a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,361.19,494.33Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,361.19,491.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.19,496.09a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,361.19,496.09Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,361.19,490.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.19,451.44a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,361.19,451.44Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,361.19,448.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.19,453.2a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,361.19,453.2Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,361.19,447.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 350.91,
    y: 356.84,
    width: 2.35,
    height: 159.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 349.14,
    y: 362.71,
    width: 2.35,
    height: 151.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 353.84,
    y: 362.71,
    width: 2.35,
    height: 151
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.1,551.61H314.48a30.88,30.88,0,0,1-30.85-30.85v-4.41H419.95v4.41A30.88,30.88,0,0,1,389.1,551.61Zm-96.21-26.44a22.07,22.07,0,0,0,21.59,17.63H389.1a22.07,22.07,0,0,0,21.59-17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M414.47,158.92h0a15.91,15.91,0,0,1,19.19,11.73l3.78,15.66a15.91,15.91,0,0,1-11.73,19.19h0a15.91,15.91,0,0,1-19.19-11.73l-3.78-15.66A15.91,15.91,0,0,1,414.47,158.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M400.35,152h0a15.91,15.91,0,0,1,22.09,4.25h0a15.91,15.91,0,0,1-4.25,22.09h0a15.91,15.91,0,0,1-22.09-4.25h0A15.91,15.91,0,0,1,400.35,152Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M413.54,272.78c3.78-6.12,6.46-11.31,6.87-11.13s-1.76,5.7-5.6,11.91-7.79,10.63-8.1,10.38S409.79,278.92,413.54,272.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 418.88,
    cy: 276.29,
    rx: 8.69,
    ry: 0.75,
    transform: "translate(-31.54 497.45) rotate(-59.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M415,276.85c5.52,2.23,10.13,3.77,10,4.18s-5-.51-10.58-2.79-9.77-5-9.57-5.32S409.5,274.63,415,276.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M420.25,275.35c5,2.35,9.23,3.83,9.11,4.24s-4.62-.49-9.74-2.88-8.71-5.29-8.48-5.59S415.25,273,420.25,275.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M365.95,91.81c3.78-6.12,6.46-11.31,6.87-11.13s-1.76,5.7-5.6,11.91-7.79,10.63-8.1,10.38S362.19,97.95,365.95,91.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 371.29,
    cy: 95.33,
    rx: 8.69,
    ry: 0.75,
    transform: "translate(100.99 367.14) rotate(-59.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M367.43,95.88c5.52,2.23,10.13,3.77,10,4.18s-5-.51-10.58-2.79-9.77-5-9.57-5.32S361.91,93.66,367.43,95.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M372.66,94.38c5,2.35,9.23,3.83,9.11,4.24s-4.62-.49-9.74-2.88-8.71-5.29-8.48-5.59S367.66,92.07,372.66,94.38Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 274.23,
    y: 119.76,
    width: 146.89,
    height: 2.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "434.17 130.52 270.07 130.52 272.07 121.71 433.17 121.71 434.17 130.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.35,521.65H290.24c-7.63,0-14.47-3.39-17.85-8.85-12.93-21-43-84.9-43-225.3,0-137.6,72.49-238.35,103.66-275.28a23.89,23.89,0,0,1,36.52,0h0C400.73,49.15,473.23,149.9,473.2,287.5c0,140.37-30.07,204.32-43,225.3C426.87,518.25,420,521.65,412.35,521.65ZM351.28,12.55a15,15,0,0,0-9.7,3.55,15.11,15.11,0,0,0-1.8,1.8C309.24,54.09,238.2,152.8,238.2,287.5c0,60.21,5.58,112.66,16.58,155.9,9.07,35.64,19.62,55.88,25.11,64.77,1.72,2.79,5.89,4.66,10.35,4.66H412.35c4.49,0,8.64-1.87,10.34-4.65,5.49-8.91,16-29.16,25.12-64.79,11-43.24,16.58-95.69,16.58-155.9,0-134.69-71-233.4-101.56-269.59h0a15,15,0,0,0-10.25-5.3Q351.93,12.55,351.28,12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.86,516.18h-8.81V431.92A115.85,115.85,0,0,1,348.84,352l3.23-3.41,3.2,3.43a115.93,115.93,0,0,1,31.22,79.29v84.74h-8.81V431.33A107.11,107.11,0,0,0,352,361.63a107,107,0,0,0-26.16,70.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M497.5,468.47a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,497.5,468.47Zm0-2.94a.88.88,0,1,0,.88.88A.88.88,0,0,0,497.5,465.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M497.5,470.24a3.82,3.82,0,1,1,3.82-3.82A3.82,3.82,0,0,1,497.5,470.24Zm0-5.29a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,497.5,464.95Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.5c11b95d5067a9aa8640f8e48505c684.svg";
export { ForwardRef as ReactComponent };